import { render, staticRenderFns } from "./AccidentsCountInput.vue?vue&type=template&id=23e8c436&"
import script from "./AccidentsCountInput.vue?vue&type=script&lang=js&"
export * from "./AccidentsCountInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports